/**
 * location.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 입지 탭에서 사용하는 데이터의 모음입니다.
 * 일부 데이터는 직접 입지 페이지 컴포넌트에 넣는 경우도 존재합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

// 주변시설 이미지
import img1 from 'assets/Desktop/images/parcelOut/faci01.jpg';
import img2 from 'assets/Desktop/images/parcelOut/faci02.jpg';
import img3 from 'assets/Desktop/images/parcelOut/faci03.jpg';
import img4 from 'assets/Desktop/images/parcelOut/faci04.jpg';
import img5 from 'assets/Desktop/images/parcelOut/faci05.jpg';
import img6 from 'assets/Desktop/images/parcelOut/faci06.jpg';
import img7 from 'assets/Desktop/images/parcelOut/faci07.jpg';
import img8 from 'assets/Desktop/images/parcelOut/faci08.jpg';
import img9 from 'assets/Desktop/images/parcelOut/faci09.jpg';
import img10 from 'assets/Desktop/images/parcelOut/faci10.jpg';
import img11 from 'assets/Desktop/images/parcelOut/faci11.jpg';
import img12 from 'assets/Desktop/images/parcelOut/faci12.jpg';
import img13 from 'assets/Desktop/images/parcelOut/faci13.jpg';

import PositionImg from 'assets/Desktop/images/parcelOut/cg_wide_map.png';
import PositionImgBig from 'assets/Desktop/images/parcelOut/cg_wide_map_big.png';
import wideBirdsView from 'assets/Desktop/images/parcelOut/cg_birds_view.jpg'

/**
 * 입지 탭에서 주변 시설의 하단 주변시설 리스트에 사용하는 데이터 목록.
 * 아래 데이터는 클릭 시 네이버 맵에 반영됩니다.
 */
export interface ILocation {
  img: string;
  title: string;
  address: string;
}

/**
 * 주변시설의 컨텐츠를 지정합니다.
 * 각각 대표 이미지, 타이틀, 네이버맵에 연결될 주소를 설정합니다.
 */
export const dataSlide: Array<ILocation> = [
  {
    img: img1,
    title: '구미IC',
    address: '경상북도 구미시 광평동 418-1'
  },
  {
    img: img2,
    title: '남구미IC',
    address: '경상북도 구미시 임오동 산45-4'
  },
  {
    img: img3,
    title: '사곡역(예정)',
    address: '경북 구미시 상사서로 173-16'
  },
  {
    img: img4,
    title: '구미역',
    address: '경북 구미시 구미중앙로 76'
  },
  {
    img: img5,
    title: '금오산',
    address: '경북 구미시 남통동 288-2'
  },
  {
    img: img6,
    title: '금오랜드',
    address: '경북 구미시 금오산로 341'
  },
  {
    img: img7,
    title: '새마을운동 테마공원',
    address: '경북 구미시 박정희로 155'
  },
  {
    img: img8,
    title: '지산샛강생태공원',
    address: '경북 구미시 지산동 845-85'
  },
  {
    img: img9,
    title: '정수초등학교',
    address: '경북 구미시 박정희로 120 정수초등학교'
  },
  {
    img: img10,
    title: '상모중학교',
    address: '경북 구미시 상사동로 70 상모중학교'
  },
  {
    img: img11,
    title: '상모고등학교',
    address: '경북 구미시 박정희로 60-22 상모고등학교'
  },
  {
    img: img12,
    title: '사곡고등학교',
    address: '경북 구미시 박정희로 195 사곡고등학교'
  },
  {
    img: img13,
    title: '구미국가산업 1단지',
    address: '경북 구미시 공단동 266-7'
  }
];

/**
 * @데스크탑
 * 입지 탭에서 위치 메뉴에서 사용하는 데이터 목록.
 */
export const titleContent = {
  tit: '금오산을 품은 직주근접 라이프,\n구미의 특별한 자부심이 되다',
  desc: '청라 오피스텔의 새로운 기준, e편한세상 시티 청라의 탁월한 입지를 직접 확인해 보세요',
  PositionImg,
  PositionImgBig,
  wideBirdsView,
  infoMap: `* 상기 개발계획은 사업주체, 국가기관, 지자체 및 기타 기관의 사업추진 중 변경, 지연, 취소될 수 있습니다.`,
  infoMap2: `* 본 홍보물의 일러스트(그림)는 소비자의 이해를 돕기 위해 제작된 것이므로, 실제와 다소 차이가 있을 수 있습니다.`,
  infoMap3: `* 대구권광역철도 관련 내용은 국토교통부 고시 제2021-342호 대구권 광역철도 건설사업 기본계획(변경) 및 국토교통부 고시 제2021-1017호 대구권 광역철도 건설사업 실시계획 변경(2차) 등을 참조한 것입니다.`
};

/**
 * @모바일
 * 입지 탭에서 위치 메뉴에서 사용하는 데이터 목록.
 */
export const titleSection = {
  tit: '금오산을 품은 직주근접 라이프,\n구미의 특별한 자부심이 되다',
  desc: '청라 오피스텔의 새로운 기준,\ne편한세상 시티 청라의 탁월한 입지를 직접 확인해 보세요',
  PositionImg,
  PositionImgBig,
  wideBirdsView,
  infoMap: `* 상기 개발계획은 사업주체, 국가기관, 지자체 및 기타 기관의 사업추진 중 변경, 지연, 취소될 수 있습니다.`,
  infoMap2: `* 본 홍보물의 일러스트(그림)는 소비자의 이해를 돕기 위해 제작된 것이므로, 실제와 다소 차이가 있을 수 있습니다.`,
  infoMap3: `* 대구권광역철도 관련 내용은 국토교통부 고시 제2021-342호 대구권 광역철도 건설사업 기본계획(변경) 및 국토교통부 고시 제2021-1017호 대구권 광역철도 건설사업 실시계획 변경(2차) 등을 참조한 것입니다.`
};

// 입지 특정점 카피문구
export const contentSection = [
  {
    tit: `기대되는 미래가치 구미에서 만나는 No.1 브랜드`,
    desc: [
      '체계적인 계획에 의해 개발되는 ‛구미상모지구 도시개발사업’으로 쾌적하고 편리한 생활환경 기대',
      '대구권 광역철도 개통 예정으로 구미~경산 간 40분대 이동이 가능한 쾌속교통',
      'LG이노텍 등 대기업의 대규모 투자로 기대되는 구미의 미래가치'
    ]
  },
  {
    tit: `금오산으로 삶의 여유까지 더하는 완벽한 브랜드 라이프`,
    desc: [
      '금오산과 새마을운동 테마공원 등으로 누리는 그리너리 라이프',
      '구미국가산업단지로 빠르게 출퇴근이 가능한 직주근접 아파트',
      '구미IC, 남구미IC, 구미역 인접으로 편리한 광역 교통 프리미엄',
      '정수초, 상모중, 상모고, 사곡고 등 우수한 교육환경'
    ]
  },
  {
    tit: 'e편한세상의 역량이 집중된 라이프스타일, 맞춤 주거 플랫폼 C2하우스',
    desc: [
      'e편한세상만의 혁신 설계 C2하우스 적용',
      '미세먼지 걱정 없는 스마트 클린&케어 솔루션 적용(미세먼지 저감식재, 미스트 분사 시설물, 스마트 공기 제어 시스템 등)',
      '남향위주 배치(일부세대 제외)와 전세대 중대형(84㎡~116㎡)으로 구성된 620세대 브랜드 대단지',
      '삶의 품격을 높이는 피트니스, 실내골프연습장, 작은도서관 등 다양한 커뮤니티 시설'
    ]
  },
  {
    tit: '구미의 자부심이 되는 e편한세상의 브랜드 프리미엄',
    desc: [
      '소비자가 뽑은 가장 신뢰하는 브랜드 대상 총 10회 수상(디지틀조선일보)',
      '국가브랜드 대상 5년 지속 수상(조선일보)',
      '대한민국 올해의 브랜드 대상 총 7회 수상(한국소비자포럼)',
      '스타브랜드 대상 4년 지속 수상(매일경제)',
      // '‛친환경 건설산업 대상’ 총 7회 수상(중앙일보)'
    ]
  }
];
